import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

import axios from '../../utils/axios';

// import axios from "axios";

import Logo from '../../assets/logo.png';
import LogoLight from '../../assets/logo-light.png';

import {
  Flex,
  Button,
  FormControl,
  Input,
  Form,
  useColorModeValue,
  useColorMode,
  useToast,
} from '@chakra-ui/react';

import { useDispatch } from 'react-redux';
import { dispatchSignIn } from '../../redux/actions/userActions';

const Signin = () => {
  const { colorMode, toggleColorMode } = useColorMode();

  const toast = useToast();

  const textColor = useColorModeValue('black', 'blue.primary');
  const hoverColor = useColorModeValue('black', 'blue.primary');
  const borderColor = useColorModeValue('orange.primary', 'white.primary');
  const btnColor = useColorModeValue('orange.primary', 'white.primary');
  const btnHover = useColorModeValue('orange.secondary', 'white.secondary');

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [user, setUser] = useState({
    email: '',
    password: '',
    err: '',
    success: '',
  });

  const { email, password, err, success } = user;

  const handleChange = (e) => {
    const { name, value } = e.target;

    setUser({ ...user, [name]: value, err: '', success: '' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post('/api/user/signin', { email, password });

      setUser({ ...user, err: '', success: res.data.msg });

      localStorage.setItem('firstSignin', true);

      dispatch(dispatchSignIn());

      await Cookies.set('refreshtoken', res.data.refreshToken, {
        expires: 7 * 24 * 60 * 60 * 1000,
        path: '/',
      });

      toast({
        title: res.data.msg,
        status: 'success',
        duration: 2000,
        isClosable: true,
        position: 'bottom-left',
      });

      navigate('/prospects');
    } catch (error) {
      console.log(error.message);
      toast({
        title: 'Incorrect email or password',
        status: 'error',
        duration: 2000,
        isClosable: true,
        position: 'bottom-left',
      });
      // console.log(error);
    }
  };

  return (
    <Flex
      direction="column"
      position="relative"
      w="100%"
      h="100vh"
      alignItems="center"
      justifyContent="center"
    >
      <Flex
        alignItems="center"
        justifyContent="center"
        direction="column"
        background="transparent"
        px={10}
        w={{ sm: '100%', md: '400px', lg: '400px', xl: '400px' }}
      >
        <img
          src={colorMode == 'light' ? LogoLight : Logo}
          alt=""
          style={{ width: 80, marginBottom: 20 }}
        />
        <form onSubmit={handleSubmit}>
          <FormControl>
            <Input
              borderRadius="15px"
              mb="24px"
              fontSize="sm"
              type="text"
              placeholder="Your email adress"
              size="lg"
              borderColor={borderColor}
              name="email"
              value={email}
              id="email"
              onChange={handleChange}
            />
            <Input
              borderRadius="15px"
              mb="36px"
              fontSize="sm"
              type="password"
              placeholder="Your password"
              size="lg"
              borderColor={borderColor}
              name="password"
              value={password}
              id="password"
              onChange={handleChange}
            />
            <Button
              fontSize="12px"
              type="submit"
              bg={btnColor}
              w="100%"
              h="45"
              mb="20px"
              color={textColor}
              borderRadius={'12px'}
              _hover={{
                bg: btnHover,
                color: hoverColor,
              }}
              _active={{
                bg: btnHover,
                color: hoverColor,
              }}
              onClick={handleSubmit}
            >
              SIGN IN
            </Button>
          </FormControl>
        </form>
      </Flex>
    </Flex>
  );
};

export default Signin;
